import React from 'react';
import '../styles/components/Nav.scss';

const Nav = () => {
    return (
        <nav className='navbar'>
            <div className='logo'>
                <img src="/img/logo.svg" alt="dashly logo" />
            </div>
        </nav>
    )
}

export default Nav;
